import React from 'react';
import DashboardLayout from '../../../components/layout/DashboardLayout';
import { useAppContext } from '../../../context/AppContext';

export default function ManageOrders() {
  const { allOrders, allUsers } = useAppContext();

  const getUserEmail = (userId) => {
    return allUsers.find(u => u.id === userId)?.email || 'Unknown User';
  };

  return (
    <DashboardLayout>
      <div className="mb-8">
        <h1 className="text-2xl font-bold text-gray-900">Global Orders</h1>
        <p className="text-gray-500 mt-1">Track all sales across the platform.</p>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full text-left border-collapse">
          <thead>
            <tr className="border-b border-gray-100">
              <th className="pb-4 font-semibold text-gray-600">Order ID</th>
              <th className="pb-4 font-semibold text-gray-600">Customer</th>
              <th className="pb-4 font-semibold text-gray-600">Amount</th>
              <th className="pb-4 font-semibold text-gray-600">Status</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-50">
            {allOrders.map((order) => (
              <tr key={order.id}>
                <td className="py-4 text-xs font-mono text-gray-400">{order.id.split('-')[0]}...</td>
                <td className="py-4">
                  <p className="text-sm font-medium text-gray-900">{getUserEmail(order.user_id)}</p>
                  <p className="text-[10px] text-gray-400">{new Date(order.created_at).toLocaleDateString()}</p>
                </td>
                <td className="py-4 font-bold text-indigo-600">${Number(order.total_amount).toFixed(2)}</td>
                <td className="py-4">
                  <span className={`px-2 py-1 rounded-full text-[10px] font-bold uppercase ${
                    order.status === 'paid' ? 'bg-green-100 text-green-700' : 'bg-yellow-100 text-yellow-700'
                  }`}>
                    {order.status}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </DashboardLayout>
  );
}
